module.exports = __webpack_public_path__ + "static/media/start_business_02.1c17ed19.png";